const state = () => ({
  NavBar: ""
})

const mutations = {
  // update lists variables
  UpdTheme(state, data) {
    state[data.cat] = data.value;
  },
}

export default {
  namespaced: true,
  state,
  mutations
}